/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import { useAdmin, useAdminParams } from 'utils/helpers';
import { Notification } from 'utils/types';

const AutomationDescription = {
  AUTOMATION_ERROR: () => 'An error occurred in one of your automations',
};

const AutomationLogs = {
  AUTOMATION_ERROR: {
    title: 'Automation Error',
    description: (_n?: Notification) =>
      AutomationDescription.AUTOMATION_ERROR(),
    element: ({ referenceId, meta }: Notification) => {
      const { isAdmin } = useAdmin();
      const {
        state: { isPreview },
      } = useAppWrapperContext();

      const navigate = useNavigate();
      const { accountId, accountUserId } = useAdminParams();

      const link = useMemo(() => {
        if (!isAdmin && !isPreview) return `/automation/${referenceId}`;

        return `/preview/accounts/${accountId}/users/${accountUserId}/automation/${referenceId}`;
      }, [isAdmin, isPreview, referenceId, accountId, accountUserId]);

      const Automation = useMemo(
        () => (meta ? JSON.parse(meta as unknown as string)?.title : ''),
        [meta],
      );

      return (
        <>
          <div className="text-title font-semibold text-sm line-clamp-2">
            {AutomationDescription['AUTOMATION_ERROR']()}
          </div>
          <div className="flex font-normal space-x-2 text-sm line-clamp-2">
            <span>Automation:</span>
            <Button
              intent="link"
              onClick={() => navigate(link)}
              label={Automation}
              className="p-0 m-0"
            />
          </div>
        </>
      );
    },
  },
};

export default AutomationLogs;
